import {
	defAction
}from "../../../../helpers/defaultAction"
import {
	reAdministrativeTerritoryConstants
}from "./constants"
import api from './api'

export const reAdministrativeTerritoryActions = {
	getPaged,
	getPagedAll,
	getPagedAudit,
	getList,
	create,
	remove,
	update,
	restore,
	clear
}

function getPaged(values){
	const dispatchObj = {
		constants : reAdministrativeTerritoryConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedAll(values){
	const dispatchObj = {
		constants : reAdministrativeTerritoryConstants.GetPagedAll,
		service   : {
			func   : api.getPagedAll,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedAudit(values){
	const dispatchObj = {
		constants : reAdministrativeTerritoryConstants.GetPagedAudit,
		service   : {
			func   : api.getPagedAudit,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getList(values){
	const dispatchObj = {
		constants : reAdministrativeTerritoryConstants.GetList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function create(values){
	const dispatchObj = {
		constants : reAdministrativeTerritoryConstants.Create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function remove(values){
	const dispatchObj = {
		constants : reAdministrativeTerritoryConstants.Delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restore(values){
	const dispatchObj = {
		constants : reAdministrativeTerritoryConstants.Restore,
		service   : {
			func   : api.restore,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function update(values){
	const dispatchObj = {
		constants : reAdministrativeTerritoryConstants.Update,
		service   : {
			func   : api.update,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: reAdministrativeTerritoryConstants.CLEAR
	})
}